import { useState, useEffect } from 'react';

const useSendProfileToCompany = (restaurantId) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [isCvSent, setIsCvSent] = useState(false);

  const isCvAlreadySent = async () => {
    try {
      
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/employee/talent-pool/check?restaurantId=${restaurantId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (response.ok) {
        const data = await response.json();
        setIsCvSent(data.isCvSent); 
      } else {
        throw new Error('Failed to check CV status');
      }
    } catch (error) {
      setError(error.message);
    }
  };

  // Function to refresh CV status
  const refreshCvStatus = () => {
    isCvAlreadySent();
  };

  useEffect(() => {
    isCvAlreadySent();
  }, [restaurantId]);

  const createTalentPoolRecord = async () => {
    setIsLoading(true);
    setError(null); 
    setSuccessMessage(null); 

    if (isCvSent) {
      setError('You have already applied to this company.');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/employee/talent-pool`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', 
        body: JSON.stringify({ restaurantId }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      
      setSuccessMessage(data.message);
      setIsCvSent(true); 
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, successMessage, isCvSent, createTalentPoolRecord, refreshCvStatus };
};

export default useSendProfileToCompany;

